import React from 'react'

function DesktopIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M11.7617 0C12.4427 0 13 0.557232 13 1.23828V9.44043C13 10.1214 12.4428 10.6787 11.7617 10.6787H7.73828L8.97656 12.0713V13H4.02344V12.0713L5.26172 10.6787H1.23828C0.557261 10.6787 0 10.1215 0 9.44043V1.23828C0 0.557261 0.557232 0 1.23828 0H11.7617ZM1.23828 1.23828V8.35742H11.7617V1.23828H1.23828Z"
          fill="black"
        />
      </g>
    </svg>
  )
}

export default DesktopIcon
